import { useState, useEffect } from 'react';

// Component
import Table from "views/pages/order-list/component/Table";
import ListGrid from "views/pages/order-list/component/ListGrid";

export default function ReportNotReleased({ isLargeScreen, reduxOrderList, setCountRow, setResultModal, setNameTitle, alertData, setAlertData, loadData }) {
    const [headData, setHeadData] = useState([]);
    const [bodyData, setBodyData] = useState([]);

    useEffect(() => {
        setHeadData([
            { text: "รายการ", align: "left", width: "20%" },
            { text: "วันที่/เวลา", align: "left", width: "20%" },
            { text: "เงินเดิมพัน", align: "right", width: "15%" },
            { text: "ดูโพย", align: "center", width: "10%" },
            { text: "คืนโพย", align: "center", width: "10%" }
        ]);

        if(reduxOrderList !== null) {
            if(reduxOrderList.data !== null) {
                let dataArrNew = reduxOrderList.data.filter((item) => (item.status !== 5 && item.status !== 6 && item.status !== 7));
                setBodyData(dataArrNew);
                setCountRow(dataArrNew.length);
            }
        }
    }, [reduxOrderList]);

    return (
        // isLargeScreen ?
        // <Table 
        //     headData={headData} 
        //     bodyData={bodyData} 
        //     typeTable="notReleased" 
        //     setResultModal={setResultModal} 
        //     setNameTitle={setNameTitle} 
        //     alertData={alertData} 
        //     setAlertData={setAlertData} 
        //     loadData={loadData}
        // ></Table>
        // :
        <ListGrid 
            typeTable="notReleased" 
            bodyData={bodyData} 
            setResultModal={setResultModal} 
            setNameTitle={setNameTitle} 
            alertData={alertData} 
            setAlertData={setAlertData} 
            loadData={loadData}
            isLargeScreen={isLargeScreen}
        ></ListGrid>
    );
}